import { ComponentDocs } from "components/docs";

const FormField = () => (
  <ComponentDocs name="<Form.Field/>" entry="Field" propsEntry="FieldProps">
    {/* TODO custom field */}
  </ComponentDocs>
);

export default FormField;
